module.exports = __webpack_public_path__ + "static/staccato-27b1910375dff4fcfa25005e5f0d7d91.png";